import {LobbyImage, StoreExpansionType, GameSpeedSettings} from '@colonist/types'
import {GameModeTranslationKeyContext, TranslationObject} from '@colonist/i18n'
import {GameModeDevelopmentCardData} from './GameModeDevelopmentCardData'
import {ExtensionSettingEnum, MapSettingEnum, ModeSettingEnum, TemporaryModeSettingEnum, CurrentStateControllerTypeEnum} from '@colonist/game-base-types'
import {BaseGameModeData} from './BaseGameModeData'
import {ClassicResourceProductionController, CommodityResourceProductionController} from './ProductionController'
import {CardTypeEnum, TileCornerBuildingType} from '@colonist/game-states'
import {RUSH_GAME_SPEED_SETTINGS} from './GameTimerOptionData'

export class ModeClassic4PData extends BaseGameModeData {
    premiumExpansionAccess = []
    modeSetting = ModeSettingEnum.Classic4P
    extensionSetting = ExtensionSettingEnum.Players4
    startingSettlementPlacements = [TileCornerBuildingType.Settlement, TileCornerBuildingType.Settlement]
    activeResourceCardTypes = [CardTypeEnum.Resource]
    activeDevelopmentCardTypes = [CardTypeEnum.Development]
    startingDevelopmentCards = GameModeDevelopmentCardData.developmentCardsClassic4P
    productionController = new ClassicResourceProductionController()
    name: TranslationObject = {key: 'strings:colonistCommon.gameModes.classic4P.title'}
    active = true
    defaultMap = MapSettingEnum.Classic4P
    defaultPlayerCount = 4
    defaultVPsToWin = 10
    additionalVPsForGameModeCombinations = 0
    icon = LobbyImage.GameModeBase
    translationKeyContext = GameModeTranslationKeyContext.BaseGame

    temporaryModeSetting = TemporaryModeSettingEnum.Classic
    currentStateControllerType = CurrentStateControllerTypeEnum.Default
}

export class ModeClassicTutorial4PData extends BaseGameModeData {
    premiumExpansionAccess = []
    modeSetting = ModeSettingEnum.TutorialClassic4P
    extensionSetting = ExtensionSettingEnum.Players4
    startingSettlementPlacements = []
    activeResourceCardTypes = [CardTypeEnum.Resource]
    activeDevelopmentCardTypes = [CardTypeEnum.Development]
    startingDevelopmentCards = GameModeDevelopmentCardData.developmentCardsClassic4P
    productionController = new ClassicResourceProductionController()
    name: TranslationObject = {key: 'strings:colonistCommon.gameModes.classicTutorial4P.title'}
    active = true
    defaultMap = MapSettingEnum.TutorialClassic4P
    defaultPlayerCount = 4
    defaultVPsToWin = 10
    additionalVPsForGameModeCombinations = 0
    icon = LobbyImage.GameModeBase
    translationKeyContext = GameModeTranslationKeyContext.BaseGame

    temporaryModeSetting = TemporaryModeSettingEnum.TutorialClassic
    currentStateControllerType = CurrentStateControllerTypeEnum.Default
}

export class ModeClassicBeginner4PData extends BaseGameModeData {
    premiumExpansionAccess = []
    modeSetting = ModeSettingEnum.BeginnerModeClassic4P
    extensionSetting = ExtensionSettingEnum.Players4
    startingSettlementPlacements = []
    activeResourceCardTypes = [CardTypeEnum.Resource]
    activeDevelopmentCardTypes = [CardTypeEnum.Development]
    startingDevelopmentCards = GameModeDevelopmentCardData.developmentCardsClassic4P
    productionController = new ClassicResourceProductionController()
    name: TranslationObject = {key: 'strings:homePage.matchmakingPopup.beginnerMode.title'}
    active = true
    defaultMap: MapSettingEnum = MapSettingEnum.CampaignLevel1
    defaultPlayerCount = 4
    defaultVPsToWin = 4
    additionalVPsForGameModeCombinations = 0
    icon = LobbyImage.GameModeBase
    translationKeyContext = GameModeTranslationKeyContext.BaseGame
    defaultCardDiscardLimit = 20
    currentStateControllerType = CurrentStateControllerTypeEnum.Default
    temporaryModeSetting = TemporaryModeSettingEnum.TutorialClassic
}

export class ModeClassic56PData extends BaseGameModeData {
    premiumExpansionAccess = [StoreExpansionType.Classic56P]
    modeSetting = ModeSettingEnum.Classic56P
    extensionSetting = ExtensionSettingEnum.Players56
    startingSettlementPlacements = [TileCornerBuildingType.Settlement, TileCornerBuildingType.Settlement]
    activeResourceCardTypes = [CardTypeEnum.Resource]
    activeDevelopmentCardTypes = [CardTypeEnum.Development]
    startingDevelopmentCards = GameModeDevelopmentCardData.developmentCardsClassic56P
    productionController = new ClassicResourceProductionController()
    name: TranslationObject = {key: 'strings:colonistCommon.gameModes.classic56P.title'}
    active = true
    defaultMap = MapSettingEnum.Classic56P
    defaultPlayerCount = 6
    defaultVPsToWin = 10
    additionalVPsForGameModeCombinations = 0
    icon = LobbyImage.GameModeBase56P
    translationKeyContext = GameModeTranslationKeyContext.BaseGame

    currentStateControllerType = CurrentStateControllerTypeEnum.Default
    temporaryModeSetting = TemporaryModeSettingEnum.Classic
}

export class ModeClassic78PData extends BaseGameModeData {
    premiumExpansionAccess = [StoreExpansionType.Classic78P]
    modeSetting = ModeSettingEnum.Classic78P
    extensionSetting = ExtensionSettingEnum.Players78
    startingSettlementPlacements = [TileCornerBuildingType.Settlement, TileCornerBuildingType.Settlement]
    activeResourceCardTypes = [CardTypeEnum.Resource]
    activeDevelopmentCardTypes = [CardTypeEnum.Development]
    startingDevelopmentCards = GameModeDevelopmentCardData.developmentCardsClassic78P
    productionController = new ClassicResourceProductionController()
    name: TranslationObject = {key: 'strings:colonistCommon.gameModes.classic78P.title'}
    active = true
    defaultMap = MapSettingEnum.Classic78P
    minimumPlayerCount = 7
    defaultPlayerCount = 8
    defaultVPsToWin = 10
    additionalVPsForGameModeCombinations = 0
    icon = LobbyImage.GameModeBase78P
    translationKeyContext = GameModeTranslationKeyContext.BaseGame

    currentStateControllerType = CurrentStateControllerTypeEnum.Default
    temporaryModeSetting = TemporaryModeSettingEnum.Classic
}

export class ModeSeafarers4PData extends BaseGameModeData {
    premiumExpansionAccess = [StoreExpansionType.Seafarers4P]
    modeSetting = ModeSettingEnum.Seafarers4P
    extensionSetting = ExtensionSettingEnum.Players4
    startingSettlementPlacements = [TileCornerBuildingType.Settlement, TileCornerBuildingType.Settlement]
    activeResourceCardTypes = [CardTypeEnum.Resource]
    activeDevelopmentCardTypes = [CardTypeEnum.Development]
    startingDevelopmentCards = GameModeDevelopmentCardData.developmentCardsClassic4P
    productionController = new ClassicResourceProductionController()
    name: TranslationObject = {key: 'strings:colonistCommon.gameModes.seafarers4P.title'}
    active = true
    defaultMap = MapSettingEnum.SS1HeadingForNewShores4P
    defaultPlayerCount = 4
    defaultVPsToWin = 14
    additionalVPsForGameModeCombinations = 0
    icon = LobbyImage.GameModeSeafarers
    translationKeyContext = GameModeTranslationKeyContext.Seafarers

    currentStateControllerType = CurrentStateControllerTypeEnum.Default
    temporaryModeSetting = TemporaryModeSettingEnum.Seafarers
}

export class ModeSeafarers56PData extends BaseGameModeData {
    premiumExpansionAccess = [StoreExpansionType.Seafarers56P]
    modeSetting = ModeSettingEnum.Seafarers56P
    extensionSetting = ExtensionSettingEnum.Players56
    startingSettlementPlacements = [TileCornerBuildingType.Settlement, TileCornerBuildingType.Settlement]
    activeResourceCardTypes = [CardTypeEnum.Resource]
    activeDevelopmentCardTypes = [CardTypeEnum.Development]
    startingDevelopmentCards = GameModeDevelopmentCardData.developmentCardsClassic56P
    productionController = new ClassicResourceProductionController()
    name: TranslationObject = {key: 'strings:colonistCommon.gameModes.seafarers56P.title'}
    active = true
    defaultMap = MapSettingEnum.SS1HeadingForNewShores56P
    defaultPlayerCount = 6
    defaultVPsToWin = 14
    additionalVPsForGameModeCombinations = 0
    icon = LobbyImage.GameModeSeafarers56P
    translationKeyContext = GameModeTranslationKeyContext.Seafarers

    currentStateControllerType = CurrentStateControllerTypeEnum.Default
    temporaryModeSetting = TemporaryModeSettingEnum.Seafarers
}

export class ModeCitiesAndKnights4PData extends BaseGameModeData {
    premiumExpansionAccess = [StoreExpansionType.CitiesAndKnights4P]
    modeSetting = ModeSettingEnum.CitiesAndKnights4P
    extensionSetting = ExtensionSettingEnum.Players4
    startingSettlementPlacements = [TileCornerBuildingType.Settlement, TileCornerBuildingType.City]
    activeResourceCardTypes = [CardTypeEnum.Resource, CardTypeEnum.Commodity]
    activeDevelopmentCardTypes = [CardTypeEnum.ProgressPolitics, CardTypeEnum.ProgressScience, CardTypeEnum.ProgressTrade]
    startingDevelopmentCards = GameModeDevelopmentCardData.progressCardsCitiesAndKnights4P
    productionController = new CommodityResourceProductionController()
    name: TranslationObject = {key: 'strings:colonistCommon.gameModes.citiesAndKnights4P.title'}
    active = true
    defaultMap = MapSettingEnum.Classic4P
    defaultPlayerCount = 4
    defaultVPsToWin = 13
    additionalVPsForGameModeCombinations = 0
    icon = LobbyImage.GameModeCnK
    translationKeyContext = GameModeTranslationKeyContext.CitiesAndKnights

    currentStateControllerType = CurrentStateControllerTypeEnum.Default
    temporaryModeSetting = TemporaryModeSettingEnum.CitiesAndKnights
}

export class ModeCitiesAndKnights56PData extends BaseGameModeData {
    premiumExpansionAccess = [StoreExpansionType.CitiesAndKnights56P]
    modeSetting = ModeSettingEnum.CitiesAndKnights56P
    extensionSetting = ExtensionSettingEnum.Players56
    startingSettlementPlacements = [TileCornerBuildingType.Settlement, TileCornerBuildingType.City]
    activeResourceCardTypes = [CardTypeEnum.Resource, CardTypeEnum.Commodity]
    activeDevelopmentCardTypes = [CardTypeEnum.ProgressPolitics, CardTypeEnum.ProgressScience, CardTypeEnum.ProgressTrade]
    startingDevelopmentCards = GameModeDevelopmentCardData.progressCardsCitiesAndKnights4P
    productionController = new CommodityResourceProductionController()
    name: TranslationObject = {key: 'strings:colonistCommon.gameModes.citiesAndKnights56P.title'}
    active = true
    defaultMap = MapSettingEnum.Classic56P
    defaultPlayerCount = 6
    defaultVPsToWin = 13
    additionalVPsForGameModeCombinations = 0
    icon = LobbyImage.GameModeCitiesAndKnights56P
    translationKeyContext = GameModeTranslationKeyContext.CitiesAndKnights

    currentStateControllerType = CurrentStateControllerTypeEnum.Default
    temporaryModeSetting = TemporaryModeSettingEnum.CitiesAndKnights
}

export class ModeSeafarersAndCitiesAndKnights4PData extends BaseGameModeData {
    premiumExpansionAccess = [StoreExpansionType.CitiesAndKnightsSeafarers4P]
    modeSetting = ModeSettingEnum.CitiesAndKnightsSeafarers4P
    extensionSetting = ExtensionSettingEnum.Players4
    startingSettlementPlacements = [TileCornerBuildingType.Settlement, TileCornerBuildingType.City]
    activeResourceCardTypes = [CardTypeEnum.Resource, CardTypeEnum.Commodity]
    activeDevelopmentCardTypes = [CardTypeEnum.ProgressPolitics, CardTypeEnum.ProgressScience, CardTypeEnum.ProgressTrade]
    startingDevelopmentCards = GameModeDevelopmentCardData.progressCardsCitiesAndKnights4P
    productionController = new CommodityResourceProductionController()
    name: TranslationObject = {key: 'strings:colonistCommon.gameModes.seafarersAndCitiesAndKnights4P.title'}
    active = true
    defaultMap = MapSettingEnum.SS1HeadingForNewShores4P
    defaultPlayerCount = 4
    defaultVPsToWin = 14
    additionalVPsForGameModeCombinations = 2
    icon = LobbyImage.GameModeCnKSeafarers
    translationKeyContext = GameModeTranslationKeyContext.CitiesAndKnightsSeafarers

    currentStateControllerType = CurrentStateControllerTypeEnum.Default
    temporaryModeSetting = TemporaryModeSettingEnum.CitiesAndKnightsSeafarers
}

export class ModeSeafarersAndCitiesAndKnights56PData extends BaseGameModeData {
    premiumExpansionAccess = [StoreExpansionType.CitiesAndKnightsSeafarers56P]
    modeSetting = ModeSettingEnum.CitiesAndKnightsSeafarers56P
    extensionSetting = ExtensionSettingEnum.Players56
    startingSettlementPlacements = [TileCornerBuildingType.Settlement, TileCornerBuildingType.City]
    activeResourceCardTypes = [CardTypeEnum.Resource, CardTypeEnum.Commodity]
    activeDevelopmentCardTypes = [CardTypeEnum.ProgressPolitics, CardTypeEnum.ProgressScience, CardTypeEnum.ProgressTrade]
    startingDevelopmentCards = GameModeDevelopmentCardData.progressCardsCitiesAndKnights4P
    productionController = new CommodityResourceProductionController()
    name: TranslationObject = {key: 'strings:colonistCommon.gameModes.seafarersAndCitiesAndKnights56P.title'}
    active = true
    defaultMap = MapSettingEnum.SS1HeadingForNewShores56P
    defaultPlayerCount = 6
    defaultVPsToWin = 14
    additionalVPsForGameModeCombinations = 2
    icon = LobbyImage.GameModeSeafarersCitiesAndKnights56P
    translationKeyContext = GameModeTranslationKeyContext.CitiesAndKnightsSeafarers

    currentStateControllerType = CurrentStateControllerTypeEnum.Default
    temporaryModeSetting = TemporaryModeSettingEnum.CitiesAndKnightsSeafarers
}

export class ModeServerStressTestClassic4P extends BaseGameModeData {
    premiumExpansionAccess = []
    modeSetting = ModeSettingEnum.ServerStressTestClassic4P
    extensionSetting = ExtensionSettingEnum.Players4
    startingSettlementPlacements = []
    activeResourceCardTypes = [CardTypeEnum.Resource]
    activeDevelopmentCardTypes = []
    startingDevelopmentCards = []
    productionController = new ClassicResourceProductionController()
    name: TranslationObject = {key: 'strings:colonistCommon.gameModes.serverStressTestClassic4P.title'}
    active = true
    defaultMap = MapSettingEnum.TutorialClassic4P
    defaultPlayerCount = 4
    defaultVPsToWin = 10
    additionalVPsForGameModeCombinations = 0
    icon = LobbyImage.GameModeBase
    translationKeyContext = GameModeTranslationKeyContext.BaseGame

    currentStateControllerType = CurrentStateControllerTypeEnum.Default
    temporaryModeSetting = TemporaryModeSettingEnum.ServerStressTest
}

export class ModeColonistRushData extends BaseGameModeData {
    premiumExpansionAccess = []
    modeSetting = ModeSettingEnum.ColonistRush4P
    extensionSetting = ExtensionSettingEnum.Players4
    startingSettlementPlacements = [TileCornerBuildingType.Settlement, TileCornerBuildingType.Settlement]
    activeResourceCardTypes = [CardTypeEnum.Resource]
    activeDevelopmentCardTypes = [CardTypeEnum.Development]
    startingDevelopmentCards = GameModeDevelopmentCardData.developmentCardsClassic4P
    productionController = new ClassicResourceProductionController()
    name: TranslationObject = {key: 'strings:colonistCommon.gameModes.colonistRush.title'}
    active = true
    defaultMap = MapSettingEnum.Classic4P
    defaultPlayerCount = 4
    defaultVPsToWin = 10
    additionalVPsForGameModeCombinations = 0
    icon = LobbyImage.GameModeColonistRush
    translationKeyContext = GameModeTranslationKeyContext.BaseGame
    allowedGameTimers: GameSpeedSettings[] = RUSH_GAME_SPEED_SETTINGS
    defaultCardDiscardLimit = 9
    currentStateControllerType = CurrentStateControllerTypeEnum.ColonistRush
    temporaryModeSetting = TemporaryModeSettingEnum.Classic
}
